/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import RequestService from '../service/requestService';
import { countries } from '../constants/countries';
import * as consts from '../const.js';
import * as actionTypes from './actionTypes';
import { SELECTED_SPONSOR } from '../constants/common';
import { MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION, MODAL_TYPE_WAITING } from '../constants/modalTypes';
import AuthService from '../service/authService';
import { clearStorage, deleteCookie, TOKEN_COOKIE_OPTIONS } from '../utils/cookieHelpers';
import { oktaClient } from '../service/oktaAuth';

export const loginSuccess = (authdata) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    payload: authdata
  };
};

export const loginError = (authdata) => {
  return {
    type: actionTypes.LOGIN_ERROR,
    payload: authdata
  };
};

export const logout = () => {
  return {
    type: actionTypes.LOGOUT
  };
};

export function logOutAndCleanSession(SSOLogoutUrl) {
  return function (dispatch) {
    dispatch(logout());
    setTimeout(() => {
      //FS endpoint that will initiate single logout on ping
      // window.location = Request.instance().buildStartSLO(); //todo: uncomment once we can check issuer from token
      try {
        AuthService.deleteTokens();
        RequestService.deleteQlikSession();
      } catch (err) {
        console.error('Delete token or Qlik session failed on logout::', err);
      }
      deleteCookie('SH-Session');
      deleteCookie('authenticated', TOKEN_COOKIE_OPTIONS);
      deleteCookie('id_token', TOKEN_COOKIE_OPTIONS);
      clearStorage();
      // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
      oktaClient.signOut();
      // }
    });
    sessionStorage.removeItem(SELECTED_SPONSOR);
  };
}

export const showModal = (type, props) => {
  return {
    type: actionTypes.SHOW_MODAL,
    payload: {
      type,
      props
    }
  };
};

export const showMigrationModal = () => {
  return {
    type: actionTypes.SHOW_MIGRATION_MODAL
  };
};

export const showMigrationSuccessModal = () => {
  return {
    type: actionTypes.SHOW_MIGRATION_MODAL_SUCCESS
  };
};

export const showMigrationErrorModal = () => {
  return {
    type: actionTypes.SHOW_MIGRATION_MODAL_ERROR
  };
};

export const hideModal = () => {
  return {
    type: actionTypes.HIDE_MODAL
  };
};

export const hideMigrationModal = () => {
  return {
    type: actionTypes.HIDE_MIGRATION_MODAL
  };
};

export const hideMigrationSuccessModal = () => {
  return {
    type: actionTypes.HIDE_MIGRATION_MODAL_SUCCESS
  };
};

export const hideMigrationErrorModal = () => {
  return {
    type: actionTypes.HIDE_MIGRATION_MODAL_ERROR
  };
};

export function openSponsorModal(type, props) {
  return function (dispatch) {
    dispatch(showModal(type, props));
  };
}

export const selectSponsor = (sponsor) => {
  return {
    type: actionTypes.SELECT_SPONSOR,
    payload: sponsor
  };
};

export const updateSponsorSelection = (sponsor) => {
  return {
    type: actionTypes.UPDATE_SPONSOR_SELECTION,
    payload: sponsor
  };
};

export const throwSelectSponsorError = (error) => {
  return {
    type: actionTypes.SELECT_SPONSOR_ERROR,
    payload: error
  };
};

export const throwUserAllocationsError = (error) => {
  return {
    type: actionTypes.USER_ALLOCATIONS_ERROR,
    payload: error
  };
};

export const fetchingUserDetailsPending = () => ({ type: actionTypes.FETCHING_USER_DETAILS_PENDING });
export const fetchingUserDetailsSuccess = () => ({ type: actionTypes.FETCHING_USER_DETAILS_SUCCESS });
export const fetchingUserDetailsFail = () => ({ type: actionTypes.FETCHING_USER_DETAILS_FAIL });

export function selectTenantAndSetCookie(tenant, history) {
  return function (dispatch, getState) {
    dispatch(fetchingTenantCookie());
    return RequestService.getTenantCookie(tenant.id)
      .then(async (response) => {
        dispatch(fetchedTenantCookie(response));
        dispatch(selectSponsor(tenant));

        const userData = getState().login.user;
        dispatch(fetchingUserDetailsPending());
        const updatedUserData = await RequestService.getUserById(userData.userId).catch((err) => {
          dispatch(fetchingUserDetailsFail());
          if (err.response.status === 403) history.push('/manager/403');
          throw err;
        });

        dispatch(fetchingUserDetailsSuccess());
        const { firstName, lastName, lang, isParticipant, hiredOrganization } = updatedUserData.data.getUserById;

        dispatch(
          loginSuccess({
            user: {
              ...userData,
              firstName,
              lastName,
              lang,
              isParticipant,
              hiredOrganization
            }
          })
        );
      })
      .catch((error) => {
        dispatch(errorFetchingTenantCookie(error));
      });
  };
}

export const fetchingTenantCookie = () => {
  return {
    type: actionTypes.FETCHING_TENANT_COOKIE
  };
};

export const fetchedTenantCookie = (data) => {
  return {
    type: actionTypes.FETCHED_TENANT_COOKIE,
    payload: data
  };
};

export const errorFetchingTenantCookie = (error) => {
  return {
    type: actionTypes.ERROR_FETCHING_TENANT_COOKIE,
    payload: error
  };
};

export const fetchingActiveStudies = () => {
  return {
    type: actionTypes.FETCHING_ACTIVE_STUDIES
  };
};

export function fetchActiveStudies(userId, sponsor) {
  return function (dispatch) {
    dispatch(fetchingActiveStudies());
    return RequestService.getAllActiveStudies(userId, sponsor)
      .then((response) => {
        dispatch(fetchedActiveStudies(response));
      })
      .catch((error) => {
        dispatch(fetchActiveStudiesError(error));
      });
  };
}

export const fetchedActiveStudies = (activeStudies) => {
  return {
    type: actionTypes.FETCHED_ACTIVE_STUDIES,
    payload: activeStudies
  };
};
export const fetchActiveStudiesError = (error) => {
  return {
    type: actionTypes.FETCH_ACTIVE_STUDIES_ERROR,
    payload: error
  };
};
export const requestOrganizations = (data) => {
  return {
    type: actionTypes.FETCHING_PEOPLE
  };
};
export const receivePeople = (data) => {
  return {
    type: actionTypes.RECEIVE_PEOPLE,
    payload: data
  };
};

export const receiveOrganizations = ({ organizations }) => {
  return {
    type: actionTypes.RECEIVE_ORGANIZATIONS,
    payload: organizations
  };
};

export const errorfetchingPeople = (errorData) => {
  return {
    type: actionTypes.ERROR_PEOPLE,
    payload: errorData
  };
};

export const publishPeopleCount = (count) => {
  return {
    type: actionTypes.PUBLISH_PEOPLE_COUNT,
    payload: count
  };
};

export const setConsentings = (consenting) => {
  return {
    type: actionTypes.SET_CONSENTING,
    consenting: consenting
  };
};

export const publishParticipantsStudyGid = (studyGid) => {
  return {
    type: actionTypes.PUBLISH_STUDY_GID,
    payload: studyGid
  };
};

export const publishNotesConsentGidAndParticipantId = (studyGid, participantId) => {
  return {
    type: actionTypes.PUBLISH_NOTES_STUDY_GID_AND_PARTICIPANT_ID,
    payload: { studyGid, participantId }
  };
};

export const fetchingDocuments = () => {
  return {
    type: actionTypes.FETCHING_DOCUMENTS
  };
};

export const receiveDocuments = (data) => {
  return {
    type: actionTypes.RECEIVE_DOCUMENTS,
    payload: data
  };
};

export function fetchDocuments(data) {
  return function (dispatch) {
    dispatch(fetchingDocuments());
    return RequestService.getConsentDocuments(data.studyId, data.participantId)
      .then((response) => {
        dispatch(receiveDocuments(response.data.documents));
      })
      .catch((error) => {
        dispatch(errorFetchingDocuments(error));
      });
  };
}

export const errorFetchingDocuments = (errorData) => {
  return {
    type: actionTypes.ERROR_DOCUMENTS,
    payload: errorData
  };
};

export const errorFetchingPdf = (errorData) => {
  return {
    type: actionTypes.ERROR_PDF,
    payload: errorData
  };
};

export const fetchingPdf = () => {
  return {
    type: actionTypes.FETCHING_PDF
  };
};

export const receivePdf = (data) => {
  return {
    type: actionTypes.RECEIVE_PDF,
    payload: data
  };
};

export const closeDocumentPdf = () => {
  return {
    type: actionTypes.CLOSE_DOCUMENT_PDF
  };
};

export const fetchConsentPdf = (consentId, consentingId, isSigned, addendumId) => {
  return function (dispatch) {
    dispatch(fetchingPdf());
    let printAction;
    if (addendumId !== undefined) {
      printAction = RequestService.getAddendumPdf(addendumId);
    } else if (isSigned) {
      printAction = RequestService.getSignedPdf(consentingId);
    } else if (consentingId) {
      printAction = RequestService.getPendingPdf(consentId, consentingId);
    } else {
      printAction = RequestService.getDocumentUnassignedPdfUrl(consentId);
    }

    return printAction
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const fileReader = new FileReader();
        fileReader.onload = function () {
          dispatch(receivePdf({ objectBlob: blob, pdfArrayBuffer: this.result }));
        };
        fileReader.readAsArrayBuffer(response.data);
      })
      .catch((error) => {
        dispatch(errorFetchingPdf(error));
      });
  };
};

export const fetchConsentMetadata = (consentingGid, studyGid, userId) => {
  return function (dispatch) {
    const consentingData = RequestService.getDocumentMetadata(consentingGid);
    consentingData
      .then((data) => {
        const consentingData = data.data.consentingData;
        dispatch(setConsentings(consentingData));
        dispatch(generatePdf(consentingGid, studyGid, userId));
      })
      .catch(err);
  };
};

export const generatePdf = (consentingGid, studyId, userId) => {
  return function (dispatch, getState) {
    const consenting = getState().documentStatus.consenting;
    RequestService.putSignedPdf(consentingGid, consenting)
      .then(() => {
        dispatch(fetchDocuments({ studyId, participantId: userId }));
      })
      .catch((err) => dispatch(errorFetchingDocuments(err)));
  };
};

export const setClientConfiguration = (data) => {
  return {
    type: actionTypes.SET_CLIENT_CONFIGURATION,
    payload: data
  };
};

export function fetchSubjectPhiInformation(studyGid, participantId) {
  return function (dispatch) {
    dispatch(fetchingSubjectPhiInformation());
    return RequestService.getSubjectPhiInformation(studyGid, participantId)
      .then((response) => {
        dispatch(fetchedSubjectPhiInformation(response));
      })
      .catch((error) => {
        dispatch(fetchingSubjectPhiInformationError(error));
      });
  };
}

export const fetchingSubjectPhiInformation = () => {
  return {
    type: actionTypes.FETCHING_SUBJECT_PHI_INFORMATION
  };
};

export const fetchedSubjectPhiInformation = (subjectPhiInformation) => {
  return {
    type: actionTypes.FETCHED_SUBJECT_PHI_INFORMATION,
    payload: subjectPhiInformation
  };
};

export const fetchingSubjectPhiInformationError = (error) => {
  return {
    type: actionTypes.FETCH_SUBJECT_PHI_INFORMATION_ERROR,
    payload: error
  };
};

export function fetchStudyInformation(studyGid) {
  return function (dispatch) {
    dispatch(fetchingStudyInformation());
    return RequestService.getStudyInformation(studyGid)
      .then((response) => {
        dispatch(fetchedStudyInformation(response));
      })
      .catch((error) => {
        dispatch(fetchingStudyInformationError(error));
      });
  };
}

export const fetchingStudyInformation = () => {
  return {
    type: actionTypes.FETCHING_STUDY_INFORMATION
  };
};

export const fetchedStudyInformation = (response) => {
  return {
    type: actionTypes.FETCHED_STUDY_INFORMATION,
    payload: { participantStudy: response.data.study }
  };
};

export function fetchSignedConsentingsNumber(studyGid) {
  return function (dispatch) {
    return RequestService.countSignedConsentings(studyGid)
      .then((response) => {
        dispatch(fetchedNumberOfSignedConsentings(response));
      })
      .catch((error) => {
        dispatch(fetchedNumberOfSignedConsentingsError(error));
      });
  };
}

export const fetchedNumberOfSignedConsentings = (response) => {
  const signedConsentingsCount = response && response.data ? response.data.signedConsentingsCount : null;
  return {
    type: actionTypes.FETCHED_SIGNED_CONSENTINGS_NO,
    payload: signedConsentingsCount
  };
};

export const fetchedNumberOfSignedConsentingsError = (error) => {
  return {
    type: actionTypes.FETCHED_SIGNED_CONSENTINGS_NO_ERROR,
    payload: error
  };
};

export function fetchSiteInformation(studyGid, participantId) {
  return function (dispatch) {
    dispatch(fetchingSiteInformation);
    return RequestService.getSiteInformation(studyGid, participantId)
      .then((response) => {
        dispatch(fetchedSiteInformation(response));
      })
      .catch((error) => {
        dispatch(fetchingSiteInformationError(error));
      });
  };
}

export const fetchingStudyInformationError = (error) => {
  return {
    type: actionTypes.FETCH_STUDY_INFORMATION_ERROR,
    payload: error
  };
};

export const fetchingSiteInformation = () => {
  return {
    type: actionTypes.FETCHING_SITE_INFORMATION
  };
};

export const fetchedSiteInformation = (response) => {
  return {
    type: actionTypes.FETCHED_SITE_INFORMATION,
    payload: { participantSites: response.data }
  };
};

export const fetchingSiteInformationError = (error) => {
  return {
    type: actionTypes.FETCH_SITE_INFORMATION_ERROR,
    payload: error
  };
};

export const createNewNote = (noteDetails) => {
  return {
    type: actionTypes.CREATE_NEW_NOTE,
    payload: noteDetails
  };
};

export const fetchingConsentDocumentsForParticipant = () => {
  return {
    type: actionTypes.FETCHING_CONSENT_DOCUMENTS_FOR_PARTICIPANT
  };
};

export const fetchedConsentDocumentsForParticipant = (document) => {
  return {
    type: actionTypes.FETCHED_CONSENT_DOCUMENTS_FOR_PARTICIPANT,
    payload: document
  };
};

export const fetchConsentDocumentsForParticipantError = (error) => {
  return {
    type: actionTypes.FETCH_CONSENT_DOCUMENTS_FOR_PARTICIPANT_ERROR,
    payload: error
  };
};

export function fetchConsentDocumentForParticipant(consentGid) {
  return function (dispatch) {
    dispatch(fetchingConsentDocumentsForParticipant());
    return RequestService.getConsentDocumentForParticipant(consentGid)
      .then((response) => {
        dispatch(fetchedConsentDocumentsForParticipant(response));
      })
      .catch((error) => {
        dispatch(fetchConsentDocumentsForParticipantError(error));
      });
  };
}

export const publishConsentDocumentsForParticipant = (consentGid, consentingGid) => {
  return {
    type: actionTypes.PUBLISH_DOCUMENTS_METADATA_FOR_ADD_NOTES,
    payload: { consentGid, consentingGid }
  };
};

export const updateAddNoteConsentGid = (consentGid) => {
  return {
    type: actionTypes.UPDATE_ADD_NOTE_CONSENT_GID,
    payload: consentGid
  };
};

export const clearNewNoteForm = () => {
  return {
    type: actionTypes.CLEAR_NEW_NOTE_FORM
  };
};

export function postNewNote(consentingGid, note) {
  return function (dispatch) {
    return RequestService.postNoteForConsenting(consentingGid, note)
      .then((response) => {
        dispatch(postNewNoteSuccess(response));
        dispatch(clearNewNoteForm());
        dispatch(hideModal());
        dispatch(changeTab(2));
      })
      .catch((error) => {
        dispatch(postNewNoteError(error));
      });
  };
}

export const postNewNoteSuccess = (response) => {
  return {
    type: actionTypes.POST_NEW_NOTE,
    payload: response
  };
};

export const postNewNoteError = (error) => {
  return {
    type: actionTypes.POST_NEW_NOTE_ERROR,
    payload: error
  };
};

export const changeTab = (tab) => {
  return {
    type: actionTypes.CHANGE_TAB,
    payload: tab
  };
};

export function openHelpdeskModal(type, props) {
  return function (dispatch) {
    dispatch(showModal(type, props));
  };
}

export function fetchHelpdeskPhoneNumbers() {
  return function (dispatch) {
    dispatch(fetchingHelpdeskPhoneNumbers());
    return RequestService.getAllHelpdeskPhoneNumbers()
      .then((response) => {
        dispatch(fetchedHelpdeskPhoneNumbers(response));
      })
      .catch((error) => {
        dispatch(fetchDefaultHelpdeskPhoneNumbers());
      });
  };
}

export const fetchingHelpdeskPhoneNumbers = () => {
  return {
    type: actionTypes.FETCHING_HELPDESK_PHONENO
  };
};

export const fetchedHelpdeskPhoneNumbers = (response) => {
  return {
    type: actionTypes.FETCHED_HELPDESK_PHONENO,
    payload: { helpdeskPhoneNumbers: response }
  };
};

export const fetchDefaultHelpdeskPhoneNumbers = () => {
  return {
    type: actionTypes.FETCH_DEFAULT_HELPDESK_PHONENO,
    payload: { helpdeskPhoneNumbers: countries }
  };
};

export const publishConsentGidandConsentingGidForJournal = (consentGid, consentingGid) => {
  return {
    type: actionTypes.PUBLISH_CONSENTGID_AND_CONSENTINGGID_FOR_JOURNAL,
    payload: { consentGid, consentingGid }
  };
};

export const clearJournalForm = () => {
  return {
    type: actionTypes.CLEAR_JOURNAL_FORM
  };
};

export const journalDocumentSelected = (consentingGid) => {
  return {
    type: actionTypes.JOURNAL_DOCUMENT_SELECTED,
    payload: consentingGid
  };
};

export function fetchConsentingJournal(consentingGid) {
  return function (dispatch) {
    dispatch(fetchingConsentingJournal());
    return RequestService.getConsentingJournal(consentingGid)
      .then((response) => {
        dispatch(fetchedConsentingJournal(response));
      })
      .catch((error) => {
        dispatch(fetchConsentingJournalError(error));
      });
  };
}

function downloadPDF(response, documentName) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), documentName);
  } else {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = documentName;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}

export function fetchJournalPdf(consentingGid) {
  return function (dispatch) {
    dispatch(fetchingJournalPdf());
    return RequestService.getJournalPdf(consentingGid)
      .then((response) => {
        downloadPDF(response, 'journal.pdf');
        dispatch(receiveJournalPdf(response));
      })
      .catch((error) => {
        dispatch(errorFetchingJournalPdf(error));
      });
  };
}

export const fetchingJournalPdf = () => {
  return {
    type: actionTypes.FETCHING_JOURNAL_PDF
  };
};

export const errorFetchingJournalPdf = (errorData) => {
  return {
    type: actionTypes.ERROR_JOURNAL_PDF,
    payload: errorData
  };
};

export const receiveJournalPdf = (data) => {
  return {
    type: actionTypes.RECEIVE_JOURNAL_PDF,
    payload: data
  };
};

export const fetchingConsentingJournal = () => {
  return {
    type: actionTypes.FETCHING_CONSENTING_JOURNAL
  };
};

export const fetchedConsentingJournal = (response) => {
  return {
    type: actionTypes.FETCHED_CONSENTING_JOURNAL,
    payload: response
  };
};

export const fetchConsentingJournalError = (error) => {
  return {
    type: actionTypes.FETCH_CONSENTING_JOURNAL_ERROR,
    payload: error
  };
};

export function fetchNotesPdfByStudyGidAndParticipantId(studyGid, participantId) {
  return function (dispatch) {
    dispatch(fetchingNotesPdf());
    return RequestService.getNotesPdfByStudyGidAndParticipantId(studyGid, participantId)
      .then((response) => {
        dispatch(fetchedNotesPdf(response));
      })
      .catch((error) => {
        dispatch(fetchNotesPdfError(error));
      });
  };
}

export const fetchingNotesPdf = () => {
  return {
    type: actionTypes.FETCHING_NOTES_PDF
  };
};

export const fetchedNotesPdf = (response) => {
  return {
    type: actionTypes.FETCHED_NOTES_PDF,
    payload: response
  };
};

export const fetchNotesPdfError = (error) => {
  return {
    type: actionTypes.FETCH_NOTES_ERROR,
    payload: error
  };
};

export const fetchedOrganizations = (data) => {
  return {
    type: actionTypes.FETCHED_ORGANIZATIONS,
    payload: data
  };
};

export const fetchingOrganizations = () => {
  return {
    type: actionTypes.FETCHING_ORGANIZATIONS
  };
};

export const fetchedOrganizationsError = (error) => {
  return {
    type: actionTypes.FETCHING_ORGANIZATIONS_ERROR,
    payload: error
  };
};

export function fetchOrganizationsBySponsor(sponsor) {
  return function (dispatch) {
    dispatch(fetchingOrganizations());
    return RequestService.getOrganizationsBySponsor(sponsor)
      .then((response) => {
        dispatch(fetchedOrganizations(response.data));
      })
      .catch((error) => {
        dispatch(fetchedOrganizationsError(error));
      });
  };
}

export function updateParticipantJourney(participantJourneyGid, payload) {
  return function (dispatch) {
    return RequestService.updateParticipantJourney(participantJourneyGid, payload)
      .then((response) => {
        dispatch(updatedParticipantJourney(response));
        dispatch(hideModal());
      })
      .catch((error) => {
        dispatch(updateParticipantJourneyError(error));
      });
  };
}

export const updatedParticipantJourney = (response) => {
  return {
    type: actionTypes.UPDATED_PARTICIPANT_JOURNEY,
    payload: response
  };
};

export const updateParticipantJourneyError = (error) => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_JOURNEY_ERROR,
    payload: error
  };
};

export function updateParticipantEmail(participantJourneyGid, payload) {
  return function (dispatch) {
    dispatch(updateParticipantEmailLoading());
    RequestService.updateParticipantEmail(participantJourneyGid, payload)
      .then((response) => {
        dispatch(updatedParticipantEmail(response));
        dispatch(hideModal());
      })
      .catch((error) => {
        dispatch(updateParticipantEmailError(error));
      });
  };
}

export const updatedParticipantEmail = (response) => {
  return {
    type: actionTypes.UPDATED_PARTICIPANT_EMAIL,
    payload: response
  };
};

export const updateParticipantEmailError = (response) => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_EMAIL_ERROR,
    payload: response
  };
};

export const updateParticipantEmailLoading = () => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_EMAIL_LOADING
  };
};

export const clearUpdateParticipantEmailError = () => {
  return {
    type: actionTypes.CLEAR_UPDATE_PARTICIPANT_EMAIL_ERROR
  };
};

export function fetchParticipantJourney(participantJourneyGid) {
  return function (dispatch) {
    dispatch(fetchingParticipanJourney());
    return RequestService.getParticipantJourney(participantJourneyGid)
      .then((response) => {
        dispatch(fetchedParticipantJourney(response));
      })
      .catch((error) => {
        dispatch(fetchParticipantJourneyError(error));
      });
  };
}

export const fetchingParticipanJourney = () => {
  return {
    type: actionTypes.FETCHING_PARTICIPANT_JOURNEY
  };
};

export const fetchedParticipantJourney = (response) => {
  return {
    type: actionTypes.FETCHED_PARTICIPANT_JOURNEY,
    payload: response
  };
};

export const fetchParticipantJourneyError = (error) => {
  return {
    type: actionTypes.FETCH_PARTICIPANT_JOURNEY_ERROR,
    payload: error
  };
};

export function fetchParticipantJournal(participantJourneyGid) {
  return function (dispatch) {
    dispatch(fetchingParticipantJournal());
    return RequestService.getParticipantJournal(participantJourneyGid)
      .then((response) => {
        dispatch(fetchedParticipantJournal(response));
      })
      .catch((error) => {
        dispatch(fetchParticipantJournalError(error));
      });
  };
}

export const fetchingParticipantJournal = () => {
  return {
    type: actionTypes.FETCHING_PARTICIPANT_JOURNAL
  };
};

export const fetchedParticipantJournal = (response) => {
  return {
    type: actionTypes.FETCHED_PARTICIPANT_JOURNAL,
    payload: response
  };
};

export const fetchParticipantJournalError = (error) => {
  return {
    type: actionTypes.FETCH_PARTICIPANT_JOURNAL_ERROR,
    payload: error
  };
};

export const fetchParticipantDetails = (participantJourneyGid) => {
  return function (dispatch) {
    dispatch(fetchingParticipanJourney());
    return RequestService.getParticipantJourney(participantJourneyGid)
      .then((response) => {
        dispatch(fetchedParticipantJourney(response));
        dispatch(fetchStudyInformation(response.data.studyGid));
        dispatch(fetchSubjectPhiInformation(response.data.studyGid, response.data.userId));
        dispatch(fetchSiteInformation(response.data.studyGid, response.data.userId));
        dispatch(fetchDocuments({ studyId: response.data.studyGid, participantId: response.data.userId }));
        dispatch(publishNotesConsentGidAndParticipantId(response.data.studyGid, response.data.userId));
      })
      .catch((error) => {
        dispatch(fetchParticipantJourneyError(error));
      });
  };
};

export function fetchParticipantJournalPDF(participantJourneyGid) {
  return function (dispatch) {
    dispatch(fetchingParticipantJournalPDF());
    return RequestService.getParticipantJournalPDF(participantJourneyGid)
      .then((response) => {
        downloadPDF(response, 'participantJournal.pdf');
        dispatch(fetchedParticipantJournalPDF());
      })
      .catch((error) => {
        dispatch(fetchParticipantJournalPDFError(error));
      });
  };
}

export const fetchingParticipantJournalPDF = () => {
  return {
    type: actionTypes.FETCHING_PARTICIPANT_JOURNAL_PDF
  };
};

export const fetchParticipantJournalPDFError = (errorData) => {
  return {
    type: actionTypes.ERROR_PARTICIPANT_JOURNAL_PDF,
    payload: errorData
  };
};

export const fetchedParticipantJournalPDF = () => {
  return {
    type: actionTypes.RECEIVE_PARTICIPANT_JOURNAL_PDF
  };
};

export const clearUpdateJourneyError = () => {
  return {
    type: actionTypes.CLEAR_UPDATE_ERROR
  };
};

export function uploadPdf(consentingGid, consenting, data) {
  return function (dispatch) {
    dispatch(
      showModal(MODAL_TYPE_WAITING, {
        shouldCloseOnOverlayClick: false,
        title: '',
        className: 'waiting-modal'
      })
    );

    return RequestService.postSignedPdf(consentingGid, data)
      .then((response) => {
        dispatch(hideModal());
        dispatch(fetchDocuments({ participantId: consenting.userId, studyId: consenting.studyGid }));
      })
      .catch((error) => {
        dispatch(hideModal());
        dispatch(errorFetchingDocuments(error));
      });
  };
}

export function deletePdf(consenting, payload) {
  return function (dispatch) {
    return RequestService.deleteSignedPdf(consenting.consentingGid, payload)
      .then(() => {
        dispatch(hideModal());
        dispatch(fetchDocuments({ participantId: consenting.userId, studyId: consenting.studyGid }));
      })
      .catch((error) => {
        dispatch(deleteDocumentError(error));
      });
  };
}

export function fetchAvailableDocuments(participantJourneyGid) {
  return function (dispatch) {
    dispatch(fetchingAvailableDocuments());
    return RequestService.fetchAvailableDocuments(participantJourneyGid)
      .then((response) => {
        dispatch(fetchedAvailableDocuments(response.data.consents.data));
      })
      .catch((error) => {
        dispatch(fetchAvailableDocumentsError(error));
      });
  };
}

export const fetchingAvailableDocuments = () => {
  return {
    type: actionTypes.FETCHING_AVAILABLE_DOCUMENTS
  };
};

export const fetchedAvailableDocuments = (payload) => {
  return {
    type: actionTypes.FETCHED_AVAILABLE_DOCUMENTS,
    payload
  };
};

export const fetchAvailableDocumentsError = (error) => {
  return {
    type: actionTypes.FETCH_AVAILABLE_DOCUMENTS_ERROR,
    payload: error
  };
};

export function fetchConsenting(consentingGid) {
  return function (dispatch) {
    dispatch(fetchingConsenting());
    return RequestService.fetchConsenting(consentingGid)
      .then((response) => {
        dispatch(fetchedConsenting(response.data.consentingData));
      })
      .catch((error) => {
        dispatch(fetchConsentingError(error));
      });
  };
}

export const fetchingConsenting = () => {
  return {
    type: actionTypes.FETCHING_CONSENTING
  };
};

export const fetchedConsenting = (payload) => {
  return {
    type: actionTypes.FETCHED_CONSENTING,
    payload
  };
};

export const fetchConsentingError = (error) => {
  return {
    type: actionTypes.FETCH_CONSENTING_ERROR,
    payload: error
  };
};

export function assignParticipantDocument(participantJourneyGid, consentId, operation, payload) {
  return function (dispatch) {
    dispatch(assigningParticipantDocument());
    return RequestService.assignParticipantDocument(participantJourneyGid, consentId, operation, payload)
      .then((response) => {
        dispatch(fetchParticipantJourney(response.data.add.participantJourney.gid));
        dispatch(
          fetchDocuments({
            studyId: response.data.add.participantJourney.studyGid,
            participantId: response.data.add.participantJourney.userId
          })
        );
        dispatch(hideModal());
        dispatch(deleteDocumentError(null));
      })
      .catch((error) => {
        if (operation === 'ADD') dispatch(assignParticipantDocumentError(error));
        else dispatch(deleteDocumentError(error));
      });
  };
}

export const assigningParticipantDocument = () => {
  return {
    type: actionTypes.ASSIGNING_PARTICIPANT_DOCUMENT
  };
};

export const assignParticipantDocumentError = (error) => {
  return {
    type: actionTypes.ASSIGN_PARTICIPANT_DOCUMENT_ERROR,
    payload: error
  };
};

export const deleteDocumentError = (error) => {
  return {
    type: actionTypes.DELETE_PARTICIPANT_DOCUMENT_ERROR,
    payload: error
  };
};

export const clearDocuments = () => {
  return { type: actionTypes.CLEAR_DOCUMENTS };
};

export function fetchUser(userId) {
  return function (dispatch) {
    dispatch(fetchingUser());

    return RequestService.getUserById(userId)
      .then((response) => {
        dispatch(fetchedUser(response.data.getUserById));
      })
      .catch((error) => {
        dispatch(fetchUserError(error));
      });
  };
}

export const fetchingUser = () => {
  return {
    type: actionTypes.FETCHING_USER_DETAILS
  };
};

export const fetchedUser = (user) => {
  return {
    type: actionTypes.FETCHED_USER_DETAILS,
    payload: user
  };
};

export const fetchUserError = (error) => {
  return {
    type: actionTypes.FETCH_USER_DETAILS_ERROR,
    payload: error
  };
};

export const fetchingProductiontenantForUAT = () => {
  return {
    type: actionTypes.FETCHING_PRODUCTION_TENANT_FOR_UAT
  };
};

export const fetchedProductionTenantForUAT = (tenant) => {
  return {
    type: actionTypes.FETCHED_PRODUCTION_TENANT_FOR_UAT,
    payload: tenant
  };
};

export const fetchingProductionTenantForUATError = (error) => {
  return {
    type: actionTypes.FETCHING_PRODUCTION_TENANT_FOR_UAT_ERROR,
    payload: error
  };
};

export function updateParticipantGender(participantId, payload) {
  return function (dispatch) {
    dispatch(updateParticipantGenderLoading());
    RequestService.updateParticipantGender(participantId, payload)
      .then((response) => {
        dispatch(updatedParticipantGender(response.data.participant));
        dispatch(hideModal());
      })
      .catch((error) => {
        dispatch(updateParticipantGenderError(error));
      });
  };
}

export const updatedParticipantGender = (response) => {
  return {
    type: actionTypes.UPDATED_PARTICIPANT_GENDER,
    payload: response
  };
};

export const updateParticipantGenderError = (response) => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_GENDER_ERROR,
    payload: response
  };
};

export const updateParticipantGenderLoading = () => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_GENDER_LOADING
  };
};

export const clearUpdateParticipantGenderError = () => {
  return {
    type: actionTypes.CLEAR_UPDATE_PARTICIPANT_GENDER_ERROR
  };
};

export function updateParticipantBirthdate(participantId, payload) {
  return function (dispatch) {
    dispatch(updateParticipantBirthdateLoading());
    RequestService.updateParticipantBirthdate(participantId, payload)
      .then((response) => {
        dispatch(updatedParticipantBirthdate(response.data.participant));
        dispatch(hideModal());
      })
      .catch((error) => {
        dispatch(updateParticipantBirthdateError(error));
      });
  };
}

export const updatedParticipantBirthdate = (response) => {
  return {
    type: actionTypes.UPDATED_PARTICIPANT_BIRTHDATE,
    payload: response
  };
};

export const updateParticipantBirthdateError = (response) => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_BIRTHDATE_ERROR,
    payload: response
  };
};

export const updateParticipantBirthdateLoading = () => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_BIRTHDATE_LOADING
  };
};

export function updateParticipantAddress(participantId, payload) {
  return function (dispatch) {
    dispatch(updateParticipantAddressLoading());
    RequestService.updateParticipantAddress(participantId, payload)
      .then((response) => {
        dispatch(updatedParticipantAddress(payload));
        dispatch(hideModal());
      })
      .catch((error) => {
        dispatch(updateParticipantAddressError(error));
      });
  };
}

export const updatedParticipantAddress = (response) => {
  return {
    type: actionTypes.UPDATED_PARTICIPANT_ADDRESS,
    payload: response
  };
};

export const updateParticipantAddressError = (response) => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_ADDRESS_ERROR,
    payload: response
  };
};

export const updateParticipantAddressLoading = () => {
  return {
    type: actionTypes.UPDATE_PARTICIPANT_ADDRESS_LOADING
  };
};
export const setQlikSession = (userId, sponsorId) => {
  return function (dispatch) {
    return RequestService.setQlikSession(userId, sponsorId)
      .then(() => {
        dispatch(fetchReportsInformation(sponsorId, userId));
      })
      .catch((error) => {
        dispatch(fetchQlikSessionError(error));
      });
  };
};

export const fetchReportsInformation = (sponsorId, userId) => {
  return function (dispatch) {
    dispatch(fetchingReports());
    return RequestService.getReports(sponsorId, userId)
      .then((response) => {
        dispatch(fetchedReports(response));
      })
      .catch((error) => {
        dispatch(fetchReportsError(error));
      });
  };
};

export const fetchingReports = () => {
  return {
    type: actionTypes.FETCHING_REPORTS
  };
};

export const fetchedReports = (reportSheet) => {
  return {
    type: actionTypes.FETCHED_REPORTS,
    payload: reportSheet
  };
};

export const fetchReportsError = (error) => {
  return {
    type: actionTypes.FETCH_REPORTS_ERROR,
    payload: error
  };
};

export const fetchQlikSessionError = (error) => {
  return {
    type: actionTypes.FETCH_REPORTS_ERROR,
    payload: error
  };
};

export const fetchReportsStatus = (sponsorId) => {
  return function (dispatch) {
    return RequestService.getReportsStatus(sponsorId)
      .then((response) => {
        dispatch(fetchedReportsStatus(response));
      })
      .catch((error) => {
        dispatch(fetchedReportsStatusError(error));
      });
  };
};

export const fetchedReportsStatus = (response) => {
  return {
    type: actionTypes.FETCHED_REPORTS_STATUS,
    payload: response
  };
};

export const fetchedReportsStatusError = (error) => {
  return {
    type: actionTypes.FETCHED_REPORTS_STATUS_ERROR,
    payload: error
  };
};

export const exportParticipantArchive = ({ study, username }) => {
  return function (dispatch) {
    return RequestService.exportParticipantArchive(study.gid, username, study.protocolNumber)
      .then((response) => {
        dispatch(initiatedExportParticipantArchive(study));
        dispatch(
          showModal(MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION, {
            title: consts.CONFIRM_EXPORT_MODAL_TITLE,
            shouldCloseOnOverlayClick: false,
            className: 'all-reports-modal tc-modal tc-modal-med'
          })
        );
      })
      .catch((error) => {
        dispatch(initiatedExportParticipantArchiveError(error));
      });
  };
};

export const initiatedExportParticipantArchive = (study) => {
  return {
    type: actionTypes.INITIATED_EXPORT_PARTICIPANT_ARCHIVE,
    payload: study
  };
};

export const initiatedExportParticipantArchiveError = (error) => {
  return {
    type: actionTypes.INITIATED_EXPORT_PARTICIPANT_ARCHIVE_ERROR,
    payload: error
  };
};

export const resetInitiatedExportParticipantArchive = () => {
  return {
    type: actionTypes.RESET_INITIATED_EXPORT_PARTICIPANT_ARCHIVE
  };
};

export const fetchExportArchiveStatus = (studyGid, sites = []) => {
  return function (dispatch) {
    return RequestService.getBatchArchivingStatus(studyGid, sites)
      .then((response) => {
        dispatch(fetchedExportArchiveStatus(response.data));
      })
      .catch((error) => {
        dispatch(fetchedExportArchiveStatusError(error));
      });
  };
};
export const fetchedExportArchiveStatus = (response) => {
  return {
    type: actionTypes.GET_EXPORT_ARCHIVE_STATUS,
    payload: response.NewDataAvailable.newDataAvailable
  };
};

export const fetchedExportArchiveStatusError = (error) => {
  return {
    type: actionTypes.GET_EXPORT_ARCHIVE_STATUS_ERROR,
    error: error
  };
};

export function updateIdPortalMigrationStatus(newStatus) {
  return {
    type: actionTypes.ID_PORTAL_MIGRATION_STATE_UPDATE,
    payload: newStatus
  };
}
